export const Templates = {

    ERROR_LOAD_TEMPLATE: `Ocurrió un error al cargar el componente`
}